import Loadable from '../../../components/loadable';

const EditPerformedWorkout = Loadable({
  loader: () => import('../../../pages/contacts/workouts/edit_performed_workout'),
  type: 'block',
});

angular.module('gym').value('EditPerformedWorkout', EditPerformedWorkout);
